module.exports = __webpack_public_path__ + "static/img/Jeremy_McGovern_desktop.89655c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremy_McGovern_desktop.jpg
// module id = Jhto
// module chunks = 0